export default "__VITE_ASSET__n2HLHZ$4__"